import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Loader, Text, Box } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import PrioritySelectorSingle from "../../components/general/PrioritySelectorSingle";

const PriorityNota = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'priorityNota-1',
    })

    const [data, setData] = React.useState({
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = (val) => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_nota_priority', val);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_priority_nota',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(val);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false,
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group>
                        <Text>{stateData.data.label}</Text>
                        {data.submitLoading && <Loader size="xs" />}
                    </Group>
                }
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Box mt='sm'>
                    <PrioritySelectorSingle
                        stateValue={stateData.data.value}
                        fnOnChange={(val) => submitData(val)}
                    />
                </Box>
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default PriorityNota;